














import { Component, Prop, Vue } from "vue-property-decorator";
import Lottie from "vue-lottie";
const tweeterAnim = require("@/assets/animations/tweet_politik/tweeter.json");
const logoAnim = require("@/assets/animations/tweet_politik/logo.json");

const $ = require("jquery");

@Component({
  components: {
    lottie: Lottie
  },
  props: {
    autoPlay: Boolean,
    renderer: String
  }
})
export default class Portfolio extends Vue {
  tweeterLottie:any = undefined;
  logoLottie:any = undefined;
  beenSeen:boolean = false;
  autoPlay:boolean = this.autoPlay;
  renderer:string = this.renderer;

  created() {
    if(!this.autoPlay) {
      return window.addEventListener("scroll", this.handleScroll);
    }
  }

  handleScroll() {
    if (!this.beenSeen) {
      this.beenSeen = this.isElementInView($("#tweet-politik-container"), false);
      if (this.beenSeen) {
        window.removeEventListener("scroll", this.handleScroll);
        this.tweeterLottie.play();
        this.logoLottie.play();
      }
    }
  }

  data() {
    return {
      beenSeen: false,
      tweeterAnimOpts: {
        animationData: tweeterAnim,
        loop: false,
        autoplay: false,
        renderer: this.renderer || "canvas"
      },
      logoAnimOpts: {
        animationData: logoAnim,
        loop: false,
        autoplay: false,
        renderer: "canvas"
      }
    };
  }

  mounted() {}

  handleTweeterAnim(anim: any) {
    this.tweeterLottie = anim;
    anim.onComplete = (data: any) => {
      anim.loop = true;
      anim.playSegments([90, 162], false);
    };
  }

  handleLogoAnim(anim: any) {
    this.logoLottie = anim;
  }

  isElementInView(element: object, fullyInView: boolean) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
      return pageTop < elementTop && pageBottom > elementBottom;
    } else {
      return elementTop <= pageBottom && elementBottom >= pageTop;
    }
  }

  asModal() {
    this.tweeterLottie.loop = true;
    this.tweeterLottie.playSegments([90, 162], true);
  }
}
